"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.camelToSnakeCaseObject = camelToSnakeCaseObject;
function camelToSnakeCase(str) {
    return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
}
function camelToSnakeCaseObject(obj) {
    const result = {};
    Object.keys(obj).forEach((key) => {
        result[camelToSnakeCase(key)] = obj[key];
    });
    return result;
}
